import { useSelector } from 'react-redux';

type EqualityFn<T> = (a: T, b: T) => boolean;

export function useAppSelector<T extends (...args: any) => any>(
  selector: T,
  equalityFn?: EqualityFn<ReturnType<T>>,
): ReturnType<T> {
  return useSelector(selector, equalityFn);
}
